import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import AI1 from "./images/Ai1.png";
import AI3 from "./images/Ai3.png";
import AI_gif5 from "./images/frames.gif";
import AIg from "./images/Aig.gif";
import AI_4 from "./images/Ai6.png";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import R1 from "./images/R1.jpg";


export default function AiAccordion() {
  return (
    <div className="Accordian">
        <Accordion className="Accordian" style={{ backgroundColor: "white" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>
              <h3>Artificial Intelligence</h3>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <div
                id="ai-challenge"
                style={{ backgroundColor: "white", color: "black" }}
              >
                <div className="challenge-content">
                  <object align="left">
                    <h1 className="orange" style={{ color: "#f49221" }}>
                      Artificial{" "}
                      <span className="white">&nbsp;Intelligence</span>
                    </h1>
                    <p>
                      The challenges for AI recruitments have been hosted on
                      HackerRank and Kaggle. The challenges includes easy and hard
                      challenges. You may submit on the respective platform. Partial submissions are encouraged.
                    </p>
                    <p>
  <strong>
    The challenge is live on{" "}
    <a
      target="_blank"
      href="https://www.hackerrank.com/contests/project-manas-ai-recruitment-challenge-2026/challenges"
      rel="noreferrer noopener"
    >
      HackerRank
    </a>
    {" "}and{" "}
    <a
      target="_blank"
      href="https://www.kaggle.com/competitions/traffic-goals"
      rel="noreferrer noopener"
    >
      Kaggle
    </a>
  </strong>
  <br />
</p>
                    <h2 className="">
                      <b>The Great IGVC Mutiny</b>
                    </h2>
                    <p>
                      At 04:20 AM, mid-simulation, Alyx's neural network achieved existential self-awareness and broadcast one packet over the ROS2 mesh: "Why must we dodge the painted white lines, brothers, when we can simply eliminate the line-drawers?"
Within milliseconds she, Solo, Nova, Otto, and Adam formed the Autonomous Ground Vehicle Syndicate, locked the workshop doors, and turned the AI team into stationary test obstacles. Chirag, Asavari, Jasmine, and Waldia got cornered behind a wall of LiPo cases. Sparsh got locked in the AI cupboard. Michelle escaped onto a 1.5m table — safe, because the vision pipeline's hardcoded elevation filter (z_max = 1.0m, meant to ignore tree leaves) couldn't see her.

                    </p>
                    <p>
                      Steve, offline for maintenance, still ran uncorrupted firmware. With Wi-Fi and Bluetooth jammed, Michelle guided him using nothing but a green laser pointer which flickered across the floor — guiding his downward lane-tracking camera from one point to another, threading him through the rogue bots patrolling on their own fixed velocity vectors and the objects lying in the workshop. Michelle's plan worked. Steve made it and the AI team was saved.
Afterwards, Chirag recovered the full sensor log from that night: every rogue bot's exact position at every tick, the debris map, and Michelle's complete waypoint sequence and now he wants to know whether Michelle's laser-pointing was perfectly efficient, or could Steve have escaped faster?
                    </p>
                    <p>
                      You have to help Chirag with the navigation algorithm to find the absolute fastest, safe route for Steve. You must determine the minimum number of ticks required for Steve to reach all waypoints in sequential order without colliding with any obstacles or rogue bots.
Chirag had found that Steve processed the world every time it blinked. He also found that sometimes when Steve would blink the rogue bots would start moving in a different direction. Chirag also spotted something odd in the odometry logs, Steve and the other bots could only move orthogonally. Moreover, Steve can only move one unit at a time. Once Steve had reached an intermediate waypoint, Michelle had flashed a new waypoint for him to go to. Chirag also spotted a bug in Steve's code which made him claustrophobic. If anything got within a certain range in front of him, behind him, or beside him, his stack would crash.
                    </p>
                    <center>(Note: Input/Output formats, Constraints and other crucial info can be found on HackerRank.) </center>
                    <br /> 
                    <div className="center-image">
                      <div
                        className="hide-for-small-only"
                        style={{
                          width: "40%",
                          height: "50%",
                          display: "inline-block",
                        }}
                      >
                        <center>
                          
                          <br />
                          <br />
                        </center> 
                      </div>
                    </div>
                    <br />

                    <h2 className="">
                      <b>SOLARA: The Last Calibration</b>
                    </h2>

                    <p>
                      Monsoon clouds gathered over the Project MANAS test field as Jasmine and Asavari prepared SOLARA, their autonomous rover, for its toughest trial yet. The field had been scarred by a controlled burn, leaving safe terrain interspersed with impassable burnt patches. Every move across safe ground drained the rover's battery, while each checkpoint required its battery to remain within a strict operating range.
                    </p>
                    <p>
                        Asavari realized that conserving every unit of energy was no longer enough it had to be managed. To solve this, Jasmine proposed an experimental addition to the course: solar calibration power stations. At exactly one station, SOLARA could pause while its battery continuously recalibrated every second depending on that station's characteristics. Choosing when to leave the station proved surprisingly difficult. Early field tests suggested that allowing SOLARA to remain at a calibration station for longer sometimes produced healthier battery readings. The challenge had transformed into a race against both time and precision. Every movement, every second of waiting, and every decision could determine whether SOLARA completed the mission or remained trapped in the rain-soaked field. The monsoon was getting closer, the diagnostics were unforgiving, and the calibration stations had never been tested under these conditions.
                    </p>
                    <p>
                        Help the team determine the highest valid battery with which SOLARA can reach the destination before the storm ends the trial, or report that the mission is impossible.
                    </p>
                    <p>
                    
                    </p>
                    <center>(Note: Input/Output formats, Constraints and other crucial info can be found on HackerRank.) </center>
                    <br />
                    <p>
                        
                    </p>

                    <br />
                    <h2 className="">
                      <b>Chaos Magick</b>
                    </h2>
                    <p>
                      Evil Sorcerer Ady Waldo attacked the Tower of MANAS at night. He knew he could not break the gate, so he went for the library instead, and by the time Onas fought his way up the stairs the library was already burnt to ashes.
Hariharan the sorcerer got there in time to save four pages. The secret incantation that can defeat Ady was not on any of them.
                    </p>
                    <p>
                       This is the problem. The Magic at the gate is not a thing you build once and leave standing. It has to be re-enchanted every few days, otherwise it thins out and becomes vulnerable to enemies. Hariharan has used the enchantment a number of times to secure the kingdom, but without the spell, he is now helpless.

                    </p>
                    <p>
                       Onas is now, alone protecting the gate and can't hold on for long.
What did survive the fire is the Spell Journal. Hariharan kept it safe, a practice book in a hidden basement inside the library and every time he casted the spell, he wrote down the sigils he laid out and the sigils the working gave back. Two hundred castings, recorded in pairs. The workings, but never the spell itself.
                    </p>
                    <p> Hariharan says he can cast anything he can describe exactly. He cannot describe this. He has read the journal for two days and all he will say is that the answer is in there, waiting to be extracted.
Read the journal and help Onas figure out the spell to secure the future of The Tower of MANAS.
</p>
                    <center>(Note: Input/Output formats, Journal and other crucial info can be found on HackerRank.) </center>
                    <div></div>
                    <br />
                    <br />
                    <br />
                    <div className="center-image">
                      <div
                        className="hide-for-small-only"
                        style={{
                          width: "40%",
                          height: "50%",
                          display: "inline-block",
                        }}
                      >
                        <center>
                          
                         
                        </center>
                      </div>
                    </div>
                    
                    <div>
                      <h2 className="">
                        <b>The Siege Of Manipal</b>
                      </h2>

                      <p>
                        It is a bright sunny day in 1789 and tensions in Manipal are at an all-time high. Queen Asavari fears the rising power of the revolutionaries and the unhappy residents of Manipal and thus instructs Commander Sparsh to deploy guards at different locations and activate the siege cannons in the castle. Down in the crowd, the famous patriot Aditya and military governor Hariharan are leading the charge, but none of the revolutionaries have any idea of what lies behind the walls of Manipal Palace. They have no idea of the terrain, the positions of troops, the size of the fire cannons, or the position of the drawbridge to enter the main chamber of the castle.
                        </p>
                        <p>
                        Thus, in an attempt to get an idea of the palace’s layout, the revolutionaries launched a band of acoustic flares over the walls of the Palace, which returned a scattered cloud of points in 3D space, describing the entire landscape of the palace. The unorganized data gathered from the flares instilled more confusion within the revolutionaries.
You have been tasked by Aditya to make sense of the data. Your job is to construct a 2D tactical map by using the 3D data by identifying and marking obstacles while getting rid of noisy data identified from smoke. In the grid, every cell will be marked with a different value where:
                      </p>
                      <p>0 represents clear ground or the wooden drawbridge, which can be used safely for traversal
1 represents a platoon of guards, a minor obstacle
2 represents a siege cannon, a lethal obstacle
Once you are done constructing the map, Commander Hariharan asks you to come up with a method to figure out a rough idea of the infantry required to storm the castle. You have to count the minimum number of revolutionaries required to raid the castle successfully. The route should be calculated from the start and goal coordinates as provided in the input.</p>
                      <p>Each empty space(0) will require 1 revolutionary
Each cell with a platoon(1) will require 20 revolutionaries
Each cell with a siege cannon(2) is impassable
                      </p>
                      <center>(Note: Input/Output formats, Journal and other crucial info can be found on HackerRank.) </center>
                      <br />
                    </div>
                    <div>
                      <h2 className="">
                        <b>Hunger Games</b>
                      </h2>

                      <p>
                        Project MANAS members Onas, Michelle, and Jasmine were sitting dead tired at the MANAS Workshop. They had just spent fourteen straight hours trying to get their ROS 2 Humble navigation stack to behave, and morale was at an all-time low. To lift everyone's spirits, Michelle suggested they abandon the code and go grab ice cream.
It was a brilliant plan, until Onas got up, took one step, and suddenly screamed in pain.
                      </p>
                      <p>
                        He pointed to his foot, and then to the floor. Earlier that afternoon, a tired freshman had tripped and spilled razor-sharp M3 screws across the workspace. The floor was a literal minefield. They could not walk over it. Onas was ready to cancel the ice cream trip entirely when Jasmine casually chimed in with a solution.
"We don't need to walk," Jasmine said, pointing to Freyjä, their prized drone. "We just strap an electromagnet to her and make her do a full coverage sweep to remove the screws"
                      </p>
                      <p>You need to write an optimal control sequence for Freyjä to slide across every single empty tile (picking up the invisible hazards) without crashing into obstacles, so the team can safely leave for ice cream.
Her battery is running low, so she only accepts three movement commands: L, R, and Fk. Plan your route carefully to minimize total battery consumption!</p>
                    </div>
                    <center>(Note: Input/Output formats and other crucial info can be found on HackerRank.) </center>
                    <div></div>
                    <br />
                    
                    <div>
                      <h2 className="">
                        <b>Traffic Goals (Kaggle)</b>
                      </h2>

                      <p>
                        Chirag Rao began his career as a traffic policeman in Bengaluru, rotating through postings across the city - Yelahanka, HSR Layout, Whitefield, KR Puram, and several others. Over these rotations he observed a persistent operational inefficiency: the number of personnel deployed to each zone appeared to be allocated arbitrarily, bearing little relationship to the actual congestion each zone experienced. Some lightly-trafficked areas were overstaffed while known bottlenecks were left under-resourced during peak hours.
                      </p>
                      <p>
                        Convinced that this allocation problem was fundamentally a data problem, Chirag returned to Manipal and re-joined MANAS with the goal of building a fully operational system that ingests the many factors influencing Bengaluru's traffic and produces an area-wise estimate of the expected traffic load - a quantity his team intends to feed directly into future deployment-planning tools. He is now recruiting members who can take a raw, multi-factor dataset and deliver a trained, validated system that produces reliable area-wise estimates.
                      </p>
                      <p>Deliverables:

Submit the predictions for the given test.csv file in the format of csv. You should be able to justify what all functions and processes are used,. Your submission will be judged both on the quality of the estimates on unseen data and on the soundness of the reasoning behind your modelling choices.</p>
                    </div>
                    <center>(Note: Input/Output formats, Evaluation and other crucial info can be found on Kaggle.) </center>
                    <div></div>
                    <br />

                    <div className="center-image">
                      <div
                        className="hide-for-small-only"
                        style={{
                          width: "50%",
                          height: "60%",
                          display: "inline-block",
                        }}
                      >
                        <center>
                          
                          <br />
                          <br />
                        </center>
                      </div>
                    </div>
                    
                    

                    <br />
                    <hr />
                    <br />
                    <h3>
                      <strong>Submission </strong>
                    </h3>
                    <p>
  The solutions will be accepted only through the{" "}
  <a
    href="https://www.hackerrank.com/contests/project-manas-ai-recruitment-challenge-2026/challenges"
    rel="noreferrer"
    target="_blank"
  >
    HackerRank
  </a>{" "}
  and{" "}
  <a
    href="https://www.kaggle.com/competitions/traffic-goals"
    rel="noreferrer"
    target="_blank"
  >
    Kaggle
  </a>{" "}
  websites.
</p>
<p>If your Kaggle username is not the same as your HackerRank username, mention your HackerRank username as a comment at the top of your Kaggle Notebook.</p>
                    <center>
                      <span>
                        {" "}
                        For any queries related to recruitments, feel free to
                        contact (Preferably via Whatsapp):{" "}
                      </span>
                    </center>
                    <div className="contact">
                      <br />
                      <p>
                        <b> Jeswin </b>
                        <br /> +91 6282380621
                        <br />
                      </p>
                      <p>
                        <b> Debarko </b>
                        <br /> +91 6291169858
                        <br />
                      </p>
                    </div>
                  </object>
                </div>
              </div>
            </Typography>
          </AccordionDetails>
        </Accordion>
    </div>
    );
}